import { atlas } from '~/services/serviceInstances';
import { Uuid } from '~/types/Uuid';

type DeleteQuestionParams = {
  id: Uuid;
};

export const deleteQuestion = async ({ id }: DeleteQuestionParams) => {
  return await atlas.remove(`questions/${id}`);
};
